var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9199 4.7002L14.9199 12.2998C14.9199 13.7468 13.7468 14.9199 12.2998 14.9199L3.70019 14.9199C2.25321 14.9199 1.08008 13.7468 1.08008 12.2998L1.08008 4.70019C1.08008 3.25321 2.25321 2.08008 3.7002 2.08008L12.2998 2.08008C13.7468 2.08008 14.9199 3.25321 14.9199 4.7002Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79999 3.20001V1.00001",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 3.20001V1.00001",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.79999H15",
    stroke: "black",
    strokeWidth: 1.16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.a626e555c655cac788ab84200361e3eb.svg";
export { ForwardRef as ReactComponent };